import { Card, Accordion } from 'react-bootstrap'
import SpinButton from 'SpinButton'
import { GroupSelect } from 'GroupSelect'
import { useState } from 'react'
import { useSettings } from 'Settings'
import NamedCheckbox from 'BlockDiagram/NamedCheckbox'
import ValueTransform from 'ValueTransform'

const limit = (min, max, value) => {
	return value > min && value < max
}

const lts_initial_voltage_options = [
	{ value: 0, label : "V_LTS < Vcs_hi (1.3V)"},
	{ value: 1, label : "V_LTS > Vcs_hi (1.3V)"}
]

const type_options = [
	{ value: "MAX", label : "MAX" },
	{ value: "TYP", label : "TYP" },
	{ value: "MIN", label : "MIN" },
]

const SupervisoryLevel = (props) => {
	const [settings] = useSettings()
	const sl = settings['supervisory level']
	const acc = sl['v_lvl_acc']
	const v_bat_max_hi = sl['v_bat_max_hi']
	const v_bat_max_lo = sl['v_bat_max_lo']
	const v_apl_max_hi = sl['v_apl_max_hi']
	const v_apl_max_lo = sl['v_apl_max_lo']
	const v_bat_min_hi_dis = sl['v_bat_min_hi_dis']
	const v_bat_min_hi_con = sl['v_bat_min_hi_con']
	const v_bat_min_lo = sl['v_bat_min_lo']
	const apl_enabled = sl['apl_enabled']

	const [bat_max_hi, set_bat_max_hi] = useState(v_bat_max_hi.value)
	const [bat_max_lo, set_bat_max_lo] = useState(v_bat_max_lo.value)
	const [apl_max_hi, set_apl_max_hi] = useState(v_apl_max_hi.value)
	const [apl_max_lo, set_apl_max_lo] = useState(v_apl_max_lo.value)
	const [bat_min_hi_dis, set_bat_min_hi_dis] = useState(v_bat_min_hi_dis.value)
	const [bat_min_hi_con, set_bat_min_hi_con] = useState(v_bat_min_hi_con.value)
	const [bat_min_lo, set_bat_min_lo] = useState(v_bat_min_lo.value)

	const Voltage = (v) => {
		return (`${ValueTransform(v, acc.value)}`).substr(0, 5) + " V"
	}

	return (
		<Card className="mb-3">
			<Card.Header>Supervisory Level</Card.Header>
			<Card.Body>
				<GroupSelect
					options={type_options}
					name="v_lvl_acc"
					value={acc.value}
					onChange={(v) => acc.setValue(v.value)}
				/>
				<GroupSelect
					options={lts_initial_voltage_options}
					name="LTS Initial Voltage"
					value={sl['lts initial voltage'].value}
					onChange={(v) => sl['lts initial voltage'].setValue(v.value)}
				/>
				<Accordion>
					<Accordion.Item eventKey="0">
						<Accordion.Header>bat_max</Accordion.Header>
						<Accordion.Body>
							<SpinButton
								name="v_bat_max_hi"
								unit={Voltage(v_bat_max_hi.value)}
								value={bat_max_hi}
								min={v_bat_max_lo.value + 1}
								max="55"
								step="1"
								onChange={(e) => {
									set_bat_max_hi(e.target.value)
									if (!Number.isNaN(parseFloat(e.target.value))) {
										if (limit(v_bat_max_lo.value, 55, parseFloat(e.target.value)))
											v_bat_max_hi.setValue(parseFloat(e.target.value))
									}
								}}
							/>
							<SpinButton
								name="v_bat_max_lo"
								unit={Voltage(v_bat_max_lo.value)}
								min={v_bat_min_hi_dis.value + 1}
								max={v_bat_max_hi.value - 1}
								step="1"
								value={bat_max_lo}
								onChange={(e) => {
									set_bat_max_lo(e.target.value)

									if (!Number.isNaN(parseFloat(e.target.value))) {
										if (limit(v_bat_min_hi_dis.value, v_bat_max_hi.value, parseFloat(e.target.value)))
											v_bat_max_lo.setValue(parseFloat(e.target.value))
									}
								}}
							/>
						</Accordion.Body>
					</Accordion.Item>
					<Accordion.Item eventKey="1">
						<Accordion.Header>apl_max</Accordion.Header>
						<Accordion.Body>
							<NamedCheckbox
								name="Enabled"
								value={apl_enabled.value}
								onChange={(e) => {
									apl_enabled.setValue(e.target.checked)
									if (!e.target.checked) {
										v_apl_max_hi.setValue(50)
										v_apl_max_lo.setValue(49)
										set_apl_max_hi(50)
										set_apl_max_lo(49)
									}
								}}
							/>
							<SpinButton
								name="v_apl_max_hi"
								unit={Voltage(v_apl_max_hi.value)}
								min={v_apl_max_lo.value + 1}
								max="55"
								step="1"
								value={apl_max_hi}
								onChange={(e) => {
									set_apl_max_hi(e.target.value)

									if (!Number.isNaN(parseFloat(e.target.value))) {
										if (limit(v_apl_max_lo.value, 55, parseFloat(e.target.value)))
											v_apl_max_hi.setValue(parseFloat(e.target.value))
									}
								}}
								disabled={!apl_enabled.value}
							/>
							<SpinButton
								name="v_apl_max_lo"
								unit={Voltage(v_apl_max_lo.value)}
								min={Math.max(v_bat_min_hi_dis.value, v_bat_min_hi_con.value) + 1}
								max={v_apl_max_hi.value - 1}
								step="1"
								value={apl_max_lo}
								onChange={(e) => {
									set_apl_max_lo(e.target.value)

									if (!Number.isNaN(parseFloat(e.target.value))) {
										if (limit(Math.max(v_bat_min_hi_dis.value, v_bat_min_hi_con.value), v_apl_max_hi.value, parseFloat(e.target.value)))
											v_apl_max_lo.setValue(parseFloat(e.target.value))
									}
								}}
								disabled={!apl_enabled.value}
							/>
						</Accordion.Body>
					</Accordion.Item>
					<Accordion.Item eventKey="2">
						<Accordion.Header>bat_min</Accordion.Header>
						<Accordion.Body>
							<SpinButton
								name="v_bat_min_hi_dis"
								unit={Voltage(v_bat_min_hi_dis.value)}
								min={v_bat_min_lo.value + 1}
								max={Math.min(v_bat_max_lo.value, v_apl_max_lo.value) - 1}
								step="1"
								value={bat_min_hi_dis}
								onChange={(e) => {
									set_bat_min_hi_dis(e.target.value)

									if (!Number.isNaN(parseFloat(e.target.value))) {
										if (limit(v_bat_min_lo.value, Math.min(v_bat_max_lo.value, v_apl_max_lo.value), parseFloat(e.target.value)))
											v_bat_min_hi_dis.setValue(parseFloat(e.target.value))
									}
								}}
							/>
							<SpinButton
								name="v_bat_min_hi_con"
								unit={Voltage(v_bat_min_hi_con.value)}
								min={v_bat_min_lo.value + 1}
								max={Math.min(v_bat_max_lo.value, v_apl_max_lo.value) - 1}
								step="1"
								value={bat_min_hi_con}
								onChange={(e) => {
									set_bat_min_hi_con(e.target.value)

									if (!Number.isNaN(parseFloat(e.target.value))) {
										if (limit(v_bat_min_lo.value, Math.min(v_bat_max_lo.value, v_apl_max_lo.value), parseFloat(e.target.value)))
											v_bat_min_hi_con.setValue(parseFloat(e.target.value))
									}
								}}
								/>
							<SpinButton
								name="v_bat_min_lo"
								unit={Voltage(v_bat_min_lo.value)}
								min="15"
								max={Math.min(v_bat_min_hi_dis.value, v_bat_min_hi_con.value) - 1}
								step="1"
								value={bat_min_lo}
								onChange={(e) => {
									set_bat_min_lo(e.target.value)

									if (!Number.isNaN(parseFloat(e.target.value))) {
										if (limit(15, Math.min(v_bat_min_hi_dis.value, v_bat_min_hi_con.value), parseFloat(e.target.value)))
											v_bat_min_lo.setValue(parseFloat(e.target.value))
									}
								}}
							/>
						</Accordion.Body>
					</Accordion.Item>
				</Accordion>
			</Card.Body>
		</Card>
	)
}

export default SupervisoryLevel
